/* DENKPAUSE Theme – Menü, Galerie, Warenkorb-Drawer */
(function () {
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* Mobiles Menü */
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-menu-toggle]');
    if (!t) return;
    const nav = document.getElementById(t.getAttribute('aria-controls'));
    const open = t.getAttribute('aria-expanded') !== 'true';
    t.setAttribute('aria-expanded', String(open));
    nav && nav.classList.toggle('is-open', open);
  });

  /* Produktgalerie */
  document.addEventListener('click', (e) => {
    const thumb = e.target.closest('[data-gallery-thumb]');
    if (!thumb) return;
    const gallery = thumb.closest('[data-gallery]');
    const main = gallery.querySelector('[data-gallery-main]') || gallery.querySelector('.gallery__main img');
    if (main) {
      main.src = thumb.dataset.src;
      main.srcset = thumb.dataset.srcset;
      main.alt = thumb.dataset.alt;
    }
    gallery.querySelectorAll('[data-gallery-thumb]').forEach((b) => b.setAttribute('aria-current', String(b === thumb)));
  });

  /* Variantenauswahl: Preis aktualisieren */
  document.addEventListener('change', (e) => {
    const sel = e.target.closest('[data-variant-select]');
    if (!sel) return;
    const opt = sel.options[sel.selectedIndex];
    const price = sel.closest('.product__info').querySelector('[data-price]');
    if (price && opt.dataset.price) price.textContent = opt.dataset.price;
    const url = new URL(window.location.href);
    url.searchParams.set('variant', sel.value);
    history.replaceState({}, '', url);
  });

  /* Warenkorb */
  const body = document.body;
  let lastFocus = null;

  function drawer() { return document.querySelector('[data-cart-drawer]'); }

  function openDrawer() {
    if (!drawer()) return false;
    lastFocus = document.activeElement;
    body.classList.add('drawer-open');
    drawer().focus();
    return true;
  }
  function closeDrawer() {
    body.classList.remove('drawer-open');
    if (lastFocus) lastFocus.focus();
  }

  async function refresh() {
    const sections = ['cart-drawer'];
    const page = document.querySelector('[data-cart-page]');
    const res = await fetch(`${root}?sections=${sections.join(',')}`);
    const data = await res.json();
    const html = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
    const fresh = html.querySelector('[data-cart-drawer]');
    if (fresh && drawer()) drawer().innerHTML = fresh.innerHTML;
    const cart = await (await fetch(`${root}cart.js`)).json();
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });
    if (page) window.location.reload();
  }

  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-add-to-cart]');
    if (!form || !drawer()) return;
    e.preventDefault();
    const btn = form.querySelector('[type="submit"]');
    const err = form.querySelector('[data-form-error]');
    btn && btn.classList.add('is-loading');
    try {
      const res = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
      });
      const json = await res.json();
      if (!res.ok) throw new Error(json.description || 'Das hat leider nicht geklappt.');
      if (err) err.hidden = true;
      await refresh();
      openDrawer();
    } catch (ex) {
      if (err) { err.textContent = ex.message; err.hidden = false; } else { form.submit(); }
    } finally {
      btn && btn.classList.remove('is-loading');
    }
  });

  document.addEventListener('click', async (e) => {
    const change = e.target.closest('[data-cart-change]');
    if (change) {
      e.preventDefault();
      const wrap = change.closest('.drawer, .cart-page');
      wrap && wrap.classList.add('is-loading');
      await fetch(`${root}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: change.dataset.cartChange, quantity: Number(change.dataset.qty) }),
      });
      await refresh();
      wrap && wrap.classList.remove('is-loading');
      return;
    }
    if (e.target.closest('[data-cart-open]') && !document.querySelector('[data-cart-page]')) {
      if (openDrawer()) e.preventDefault();
      return;
    }
    if (e.target.closest('[data-cart-close]')) closeDrawer();
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && body.classList.contains('drawer-open')) closeDrawer();
  });
})();
